import { useState, useRef, useEffect } from "react";
import { ChevronDown, X, Check } from "lucide-react";

export default function MultiSelect({ label, options = [], value = [], onChange, testid }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };

  const filtered = options.filter((o) => o.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="relative" ref={ref}>
      {label && <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">{label}</label>}
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-2 px-3 py-2 text-sm border border-slate-300 rounded-md bg-white hover:border-[#D96B27] transition-colors text-left"
      >
        <span className="truncate text-slate-700">{value.length ? `${value.length} selected` : "Select…"}</span>
        <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />
      </button>

      {value.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-1.5">
          {value.map((v) => (
            <span key={v} className="inline-flex items-center gap-1 text-xs bg-[#FFF3EC] text-[#C05615] px-2 py-0.5 rounded">
              {v}
              <button type="button" onClick={() => toggle(v)}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}

      {open && (
        <div className="absolute z-30 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-64 overflow-hidden">
          <div className="p-2 border-b border-slate-100">
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="w-full text-sm px-2 py-1 border border-slate-200 rounded outline-none focus:border-[#D96B27]" />
          </div>
          <div className="max-h-48 overflow-y-auto scrollbar-thin">
            {filtered.map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => toggle(opt)}
                className="w-full flex items-center justify-between px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50 text-left"
              >
                {opt}
                {value.includes(opt) && <Check className="w-4 h-4 text-[#D96B27]" />}
              </button>
            ))}
            {filtered.length === 0 && <p className="px-3 py-2 text-sm text-slate-400">No options</p>}
          </div>
        </div>
      )}
    </div>
  );
}
